import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Forms from "../../../../../Componets/Form";
import toast from "react-hot-toast";
import Header from "../../../../../Componets/Header";
import forms from "../../../../../Data/Forms/Tax/Tax/forms";
import headers from "../../../../../Data/Forms/Tax/Tax/headers";
import Loadercomponent from "../../../../../Componets/Loader";
import { create_tax, get_tax, update_tax } from "../../../../../Controllers/Tax/Tax";

const TaxForm = () => {
  let { id } = useParams();
  const [header, setHeader] = useState(headers);

  let navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [values, setValues] = useState(forms);

  const formdata = async (data) => {
    if (data?.status) {
      setButtonLoader(true);

      const tax = id
        ? await update_tax({ id: id, ...data?.data })
        : await create_tax(data?.data);

      if (tax?.status) {
        navigate(-1);
        toast?.success(tax?.message);
        setButtonLoader(false);
      } else {
        setButtonLoader(false);
        if (tax?.status_code == 403) {
          window.location.href = "/unauthorized";
        } else {
          toast?.error(tax?.message);
        }

      }
    }
  };

  const handleData = (tax) => {
    console.log("Handling tax data:", tax, forms);

    forms[0].options[0].form.value = tax?.name || "";
    forms[0].options[1].form.value = tax?.code || "";
    forms[0].options[2].form.value = tax?.description || "";

    if (tax?.taxType) {
      forms[1].options[0].form.value = tax?.name || "";
    }

    forms[1].options[1].form.value = tax?.calculationType || "";
    forms[1].options[2].form.value = tax?.rate || "";

    forms[2].options[0].form.value = tax?.applicableOn || "";
    forms[2].options[1].form.value = tax?.taxScope || "";
    forms[2].options[2].form.value = tax?.inclusiveType || "";
    forms[2].options[3].form.value = tax?.taxGroup || "";

    if (tax?.category) {
      forms[3].options[0].form.value = tax?.category.name || "";
    }

    forms[4].options[0].form.value = tax?.isCompound || false;
    forms[4].options[1].form.value = tax?.dependsOnTax || null;

    if (tax?.dependsOnTax) {
      forms[4].options[1].form.options = [
        {
          value: tax.dependsOnTax,
          label: tax.dependsOnTaxName || "",
        },
      ];
    }

    forms[4].options[2].form.value = tax?.effectiveFrom || "";
    forms[4].options[3].form.value = tax?.validUntil || "";

    setLoader(false);
    setValues([...forms]);
  };

  const fetchData = async () => {
    if (id) {
      setLoader(true);

      const data = {
        id: id,
      };

      const tax = await get_tax(data);

      if (tax?.status) {
        handleData(tax?.data);
      } else {
        toast?.error(tax?.message);
        setLoader(false);
      }
    } else {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Forms
          form={values}
          setForm={setValues}
          formdata={formdata}
          buttonLoader={buttonLoader}
        />
      </Loadercomponent>
    </Header>
  );
};

export default TaxForm;
